export default $axios => {
    return {
        $axios,

        async fetch() {
            return await $axios.get(`/addresses/`);
        },

        async delete(id) {
            return await $axios.delete(`/addresses/${id}`);
        },

        async add(address) {
            return await $axios.post(`/addresses`, address);
        },

        async update(address) {
            const _address = {
                ...address
            }
            delete _address.id;

            return await $axios.put(`/addresses/${address.id}`, _address);
        },

        async setDefault(id) {
            return await $axios.post(`/addresses/${id}/default`);
        },

        async addBillingAddress(form) {
            return await $axios.post('/client_billing_address', form);
        },

        async fetchBillingAddress() {
            return await $axios.get('/client_billing_address');
        }
    };
};